import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetCollectTrackingByOrderInput } from './GetCollectTrackingByOrderInput';
import { GetCollectTrackingByOrderOutput } from './GetCollectTrackingByOrderOutput';

export class GetCollectTrackingByOrderService extends HttpServiceBase {

  handle = (input: GetCollectTrackingByOrderInput): Promise<Result<GetCollectTrackingByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetCollectTrackingByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/collect-tracking`);
    return promise;
  }
}